import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Select, ConfigProvider } from "antd"
import { getCustomerTags } from "helpers/backend_helper"

const SelectClientTag = props => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  useEffect(() => {
    if (props.options) {
      setOptions(props.options)
    }
  }, [props.options])

  // Get entries for dropdown
  const getData = () => {
    setLoading(true)
    getCustomerTags(abortRef.current).then(result => {
      if (result.statusCode == 200 && result.entries) {

        // Sort
        result.entries.sort(function (a, b) {
          return a.localeCompare(b)
        })

        let opts = []
        let noCategory = {label: "", title: "", options: []};

        for (const entry of result.entries) {
          if (entry.indexOf(" > ") > 0) {
            let split = entry.split(" > ")
            let parent = opts.find(i => i.title == split[0])
            if (parent) {
              parent.options.push({
                label: split[1], value: entry
              })
            }
            else {
              let tag = new Object();
              tag.label = split[0];
              tag.title = split[0];
              tag.options = [{
                label: split[1], value: entry
              }];
              opts.push(tag)
            }
          }
          else {
            noCategory.options.push({
              label: entry, value: entry
            })
          }
        }
        noCategory.label = props.t("No category")
        if (noCategory.options.length > 0) opts.push(noCategory)
          
        setOptions(opts)
      }
    })
      .catch(e => {
        console.log(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // Selection changed
  const handleChange = newSelection => {
    if (props.onChange != null) {
      props.onChange(newSelection)
    }
  }

  // Custom empty/Data not found dropdown
  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      {loading
        ? <p>{props.t("Loading")}</p>
        : <p>{props.t("No entries found")}</p>
      }
    </div>
  )

  // Dropdown visibility, get data at first
  const visibilityChanged = (visible) => {
    if (visible && options.length == 0 && !loading && props.fetchData) {
      getData()
    }
  }

  // Selected item render
  const labelRender = (p) => {
    return <span>{p.value}</span>
  }

  return (
    <div>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <div className="config-provider">
          <Select
            placeholder={props.t("Select tag")}
            allowClear
            showSearch
            loading={loading}
            style={{ width: "100%", minWidth: "240px" }}
            onChange={handleChange}
            onOpenChange={visibilityChanged}
            options={options}
            labelRender={labelRender}
          />
        </div>
      </ConfigProvider>
    </div>
  )
}

SelectClientTag.propTypes = {
  t: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
  fetchData: PropTypes.bool,
}

export default withTranslation()(SelectClientTag)